export default function $localstorage($window) {
  return {
    set: function (key, value) {
      $window.localStorage[key] = value;
    },
    get: function (key, defaultValue) {
      return $window.localStorage[key] || defaultValue;
    },
    del: function (key) {
      $window.localStorage.removeItem(key);
    },
    setObject: function (key, value) {
      $window.localStorage[key] = JSON.stringify(value);
    },
    getObject: function (key) {
      return JSON.parse($window.localStorage[key] || '{}');
    }
  };
};

export function $sessionstorage($window) {
  return {
    set: function (key, value) {
      $window.sessionStorage[key] = value;
    },
    get: function (key, defaultValue) {
      return $window.sessionStorage[key] || defaultValue;
    },
    del: function (key) {
      $window.sessionStorage.removeItem(key);
    },
    setObject: function (key, value) {
      $window.sessionStorage[key] = JSON.stringify(value);
    },
    getObject: function (key) {
      return JSON.parse($window.sessionStorage[key] || '{}');
    }
  };
}

